import ApiUrl from '../services/APIUrl';
import AxiosClient from './AxiosClient';
import { EUrlParams } from '../data/Constants';

import type { IReadProducts } from '../../types/IRequestTypes';

export const ProductApi = {
  //This method returns the work item list
  getProductModels: (action: IReadProducts) => {
    const params: Record<string, string | null> = {};

    if (action?.page) {
      params[EUrlParams.Page] = `${action.page}`;
    }

    if (action?.limit) {
      params[EUrlParams.Limit] = `${action.limit}`;
    }

    if (action?.productSearch) {
      params[EUrlParams.Search] = `${action.productSearch}`;
    }

    return AxiosClient.get(ApiUrl.ReadProductModels, { params })
      .then((response) => {
        const total = JSON.parse(response.headers['x-pagination']).total;
        return {
          data: response.data,
          page: action.page,
          limit: action.limit,
          totalRecords: total,
          searchKey: action?.productSearch,
        };
      })
      .catch((err) => {
        return {
          error: err,
        };
      });
  },
};
